function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            //toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

var wFlag = window.innerWidth > 750

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(() => {
    setInterval(() => {
        $('.box1_title').css({ transform: 'translateY(0)', opacity: 1 })
    }, 300);

    //box1
    if(wFlag){
        ScrollTrigger.create({
            trigger: '.box1',
            start: 'top+=10% top',
            end: '+=200%',
            scrub: 1,
            animation: gsap.timeline()
                .to('.box1_mask', { scale: 1 })
                .to('.box1_mask', { background: 'white' }, '-=30%')
                .to('.box1m_text span', { opacity: 1, y: '0', stagger: 0.2 }, '-=20%')
                .to('.box1_specs', { opacity: 1 }, '<')
                .to('.box1m_text', { y: 0, scale: 1 })
                .to('.box1_mask', { opacity: 0 })
                .from('.box1_items .box1_item:nth-child(1)', { opacity: 0, x: '20%', y: '20%' })
                .from('.box1_items .box1_item:nth-child(2)', { opacity: 0, x: '-20%', y: '20%' }, '<')
                .from('.box1_items .box1_item:nth-child(3)', { opacity: 0, x: '20%', y: '-20%' }, '<')
                .from('.box1_items .box1_item:nth-child(4)', { opacity: 0, x: '-20%', y: '-20%' }, '<')
                .from('.box1_text', { opacity: 0, y: '2rem' })
        })

        ScrollTrigger.create({
            trigger: '.box1',
            start: 'top top',
            end: '+=240%',
            pin: true,
            anticipatePin: 1
        })
    }else{
        const items = gsap.utils.toArray('.Mbox1_text div');

        ScrollTrigger.create({
            trigger: '.Mbox1_text',
            start: 'top center+=10%',
            end: '+=60%',
            scrub: 1,
            toggleActions: 'play none none reverse',
            onUpdate(self) {
                const index = Math.min(
                    items.length - 1,
                    Math.floor(self.progress * items.length)
                );

                // 先全部恢复默认颜色
                gsap.set(items, { color: '#999' });

                // 当前这个变红
                gsap.set(items[index], { color: '#2357C7' });
            },

            // 滚出范围后全部恢复默认颜色，可按需保留
            onLeaveBack() {
                gsap.set(items, { color: '#999' });
            }
        })
    }

    //box3
    showUp('.box3_title')
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_item img').eq(index).addClass('box3Active1').siblings().removeClass('box3Active1')
                $('.box3_icon div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
            }
        },
    })
    $('.box3_icon div').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })
    $('.box3_item img').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })

    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger: '.box2',
        start: wFlag?'top center-=10%':'top center+=10%',
        end: '+=20%',
        scrub:1,
        animation: gsap.timeline()
            .from('.box2_bg', { opacity:0 })
    })
    showUp('.box2_icon')

    showUp('.box19_title')
    ScrollTrigger.create({
        trigger: '.box19',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=200%',
        scrub:1,
        animation: gsap.timeline()
            .to('.box19_item div', { y:wFlag?'-58rem':'-44rem',stagger:{each: 0.1,from: "end"}})
    })
    ScrollTrigger.create({
        trigger: '.box19',
        start: wFlag?'top+=150% top+=4%':'top+=180% top+=6%',
        end: '+=30%',
        scrub:1,
        animation: gsap.timeline()
            .from('.box19_img', { y:'20%',opacity:0,duration:0.2 })
            .from('.box19_text', { y:'2rem',opacity:0,duration:0.1 })
    })
    ScrollTrigger.create({
        trigger: '.box19',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=220%',
        pin:true,
    })

    //box4
    showUp('.box4_title')
    if(!wFlag){
        showUp('.Mbox4_text')
    }

    //box5
    ScrollTrigger.create({
        trigger: '.box5',
        start: wFlag?'top center':'top center+=10%',
        end: '+=20%',
        scrub:1, 
        animation: gsap.timeline()
            .from('.box5_title', { opacity:0 })
    })

    ScrollTrigger.create({
        trigger: '.box5',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=150%',
        scrub:1,
        pin:true,
        anticipatePin: 1,
        animation: gsap.timeline()
            .to('.box5_title span:last-child', { opacity:0 })
            .to('.box5_title', { x:wFlag?'89%':'0%',y:wFlag?'0%':'20%',scale:wFlag?1.8:1.2 },'-=20%')
            .from('.box5_img', { opacity:0,y:'5%' })
            .from('.box5_text', { opacity:0,y:'2%' })
            .from('.box5_img img:nth-child(2)', { opacity:0 })
            .from('.box5_img div', { opacity:0 },'<')
            .to({}, { duration:0.2 })
    })

    gsap.fromTo( '.box5_img div img',{ opacity: 0 },{opacity: 1,duration: 1,repeat: -1,yoyo: true,ease: 'none'});

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger: '.box6',
        start: wFlag?'top top+=4%':'top top+=6%',
        end: '+=50%',
        pin:true,
        anticipatePin: 1,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box6_left div:last-child').toggleClass('box6Active',index>4)
        }
    })

    //box7
    showUp('.box7_title')
    autoPlayOnView('.box7_video')

    //box8
    showUp('.box8_title')

    var nexlimN1 = 100,ng_flag=true,flag_ng;
    function startNG(){
        clearInterval(flag_ng); // 防止重复开启多个定时器
        flag_ng =  setInterval(num,15)
    }
    function num(){
        nexlimN1++;
        if (nexlimN1 >= 200) {
            nexlimN1 = 200;
            clearInterval(flag_ng);
        }
    
        $(`.box8_item div p c`).text(`${nexlimN1}%`);
    }

    ScrollTrigger.create({
        trigger:'.box8', 
        start:'top center',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>10){
                // 执行一次
                if(ng_flag){
                    startNG()
                    ng_flag=false;
                }
            }
            if(index<2){
                // 重置
                ng_flag=true,nexlimN1 = 100
            }
        }
    })

    //box10
    showUp('.box10_title')
    let box10Status = null;
    ScrollTrigger.create({
        trigger:'.box10', 
        start:wFlag?'top top+=2%':'top top+=6%',
        end:'+=50%',
        pin:true,
        anticipatePin: 1,
        onUpdate: (self) => {
            const isSecond = self.progress >= 0.5;
    
            if (isSecond === box10Status) return;
    
            box10Status = isSecond;
    
            $('.box10_items').toggleClass('box10Active1', isSecond);
    
            $('.box10_item')
                .removeClass('box10Active')
                .eq(isSecond ? 1 : 0)
                .addClass('box10Active');
        }
    })

    //box9
    if(wFlag){
        showUp('.box9_title')
        ScrollTrigger.create({
            trigger: '.box9',
            start: wFlag?'top top+=4%':'top top+=6%',
            end: '+=30%',
            pin:true
        })
    }

    $('.box9_title p span').click(function(){
        var index=$(this).index()
        if(index==0){
            $(this).addClass('box9btn1').siblings().removeClass('box9btn2')
            $('.box9_icon').addClass('box9Active1')
            $('.box9_color img').css({transform:'rotate(331deg) translate(0, 58rem)',transition:'all 1.5s'})
            $('.box9_color').css({animation:'none'})
        }else{
            $(this).addClass('box9btn2').siblings().removeClass('box9btn1')
            $('.box9_icon').addClass('box9Active1')
            $('.box9_color').css({animation:'box7_active1 1s'})
            //复原
            $('.box9_color img').css({transform:'rotate(331deg) translate(0, 3rem)',transition:'all 0s'})
        }
    })

    $('.box9_icon').on('animationend', function () {
        $(this).removeClass('box9Active1');
    });

    //box11
    showUp('.box11_title')
    ScrollTrigger.create({
        trigger: '.box11',
        start: wFlag?'top top+=10%':'top top+=20%',
        end: '+=0%',
        toggleActions:'play none none reverse',
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 10);
            $('.box11_icon').toggleClass('box11Active',index>4)
        }
    })

    showUp('.box12_title')
    showUp('.box13_title')
    showUp('.box14_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box16',
            start:'top top+=2%',
            end:'+=60%',
            pin:true,
            scrub:1,
            anticipatePin: 1,
            //toggleActions: 'play none none reverse',
            animation:gsap.timeline()
                .to({},{duration:0.2})
                .from('.box16_img',{y:'-16%',scale:2})
                .from('.box16_title',{opacity:0})
                .from('.box16_text',{opacity:0},'<')
                .to({},{duration:0.2})
        })
    }
    
    showUp('.box17_title')

    //box18
    showUp('.box18_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box18Swiper',
            start:'top bottom-=20%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline().to('.box18Swiper .swiper-slide',{x:0,opacity:1})
        })
        $('.box18_item').hover(function(){
            $('.box18_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box18Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
            on:{
                slideChangeTransitionEnd: function(){
                    $('.box18_item video').css({filter:'brightness(0.4)'})
                    $('.box18_item video').each(function() {
                        this.pause();
                    });
                    $('.box18Swiper .swiper-slide-active .box18_item video').css({filter:'brightness(1)'})
                    $('.box18Swiper .swiper-slide-active .box18_item video')[0].play()
                },
            },
        })
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
})

 
//boxSpecs_btn
$('.bs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-nexlim-2-mini-pod-kit-30w-1500mah-4ml'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})